<template>
    <div class="scope-arrangement-item" v-if="selectMap">
        <el-row class="top-handler-wpr" v-if="isSingle">
            <el-col>
                <el-button icon="el-icon-plus" type="primary" @click="addInterview" v-if="this.tableData.length < 4">添加面试
                </el-button>
                <div class="pull-right">
                    <arrange-common @sendEmail="sendEmail"></arrange-common>
                </div>
            </el-col>
        </el-row>
        <el-row class="top-handler-wpr mb-20" type="flex" align="middle" v-else>
            <el-col :span="19" class="name user-name">
                <thumbnail :width="36" :gender="init.resume.gender=== 2 ? 'woman': 'man'" mode="horizontal">
                    <strong><span style="color: #000;" v-text="init.resume.name"></span></strong>
                </thumbnail>
                <PIcon tooltip="应聘部门" display="inline-block" class="dept-name multi-info" icon="el-icon-my-xiugaibumen">
                    {{init.position.deptNames}}
                </PIcon>
                <PIcon tooltip="应聘职位" display="inline-block" class="dept-name multi-info" icon="el-icon-my-gongzuojingli">
                    {{init.position.name}}
                </PIcon>
                <PIcon tooltip="联系方式" display="inline-block" class="dept-name multi-info" icon="el-icon-my-shouji">
                    {{init.resume.mobilePhone || '无'}}
                </PIcon>
            </el-col>
            <el-col :span="5" class="text-right">
                <el-button icon="el-icon-plus" type="primary" @click="addInterview" v-if="this.tableData.length < 4">添加面试
                </el-button>
                <el-button type="primary" :plain="true" @click="removeInterview">移除</el-button>
            </el-col>
        </el-row>
        <div class="table-list mt-10">
            <el-table
                    :data="tableData"
                    ref="table"
                    @row-click="selectedRow"
                    :class="{'multi':!isSingle}"
                    row-class-name="interview-one">
                <el-table-column align="center" type="selection" width="50">
                </el-table-column>
                <el-table-column label="面试阶段" align="center" min-width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.isEdit">
                            <el-select size="medium" v-model="scope.row.turnType" placeholder="请选择">
                                <el-option
                                        v-for='(item, index) in turnOptions'
                                        :key='index'
                                        :label='item.label'
                                        :value='item.value'>
                                </el-option>
                            </el-select>
                        </div>
                        <template v-else>
                        <span>{{ turnMap[scope.row.turn] }}
                            <el-tag type="success" v-if="~~scope.row.isHr">HR面</el-tag>
                        </span>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="面试时间" align="center" min-width="180">
                    <template slot-scope="scope">
                        <div v-if="scope.row.isEdit">
                            <el-date-picker
                                    class="el-input--noprefix"
                                    size="medium"
                                    prefix-icon=" "
                                    v-model="scope.row.interviewDate"
                                    format="yyyy-MM-dd HH:mm"
                                    type="datetime"
                                    placeholder="选择日期时间">
                            </el-date-picker>
                        </div>
                        <div v-else>
                            <span class="ml-5">{{ dateFormat(scope.row.interviewDate) }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="面试形式" align="center" min-width="110">
                    <template slot-scope="scope">
                        <div v-if="scope.row.isEdit">
                            <el-select
                                size="medium"
                                :value='scope.row.interviewType'
                                @input="handleChangeInterviewType($event, scope.$index)"
                                placeholder='请选择'
                            >
                                <el-option v-for='(item, index) in selectMap.WB_INTERVIEW_TYPE' :key='index'
                                           :label='item.text'
                                           :value='item.value'></el-option>
                            </el-select>
                        </div>
                        <div v-else>
                            <span>{{getSelectMapText('WB_INTERVIEW_TYPE', scope.row.interviewType)}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="面试官" align="center" min-width="280">
                    <template slot-scope="scope">
                        <div v-if="scope.row.isEdit">
                            <user-search :ref="`masterInterviewer${scope.$index}`" v-model="scope.row.masterInterviewer"
                                         :index="scope.$index"
                                         holder="面试官"
                                         style="width: 95%;display: inline-block;"></user-search>
                            <user-search ref="interviewer" v-model="scope.row.interviewer" :index="scope.$index"
                                         holder="副面试官"
                                         style="width: 50%;display: none;"></user-search>
                        </div>
                        <template v-else>
                             <div style="text-align: center;">
                                 <span>
                                     <!--<span class="user-type user-main">主</span>-->
                                     <span class="mr-15">{{scope.row.masterInterviewerNames}}</span>
                                 </span>
                                 <!--<span v-if="scope.row.interviewerNames">-->
                                    <!--<span class="user-type user-assis">副</span>-->
                                    <!--<span>{{scope.row.interviewerNames}}</span>-->
                                <!--</span>-->
                             </div>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column
                        label="面试地点"
                        align="center"
                        min-width="160">
                    <template slot-scope="scope">
                        <div v-if="scope.row.isEdit" class="text-ellipsis">
                            <el-input size="medium" v-model="scope.row.interviewPlace" placeholder="请输入内容"></el-input>
                        </div>
                        <div v-else class="text-ellipsis">
                            <span>{{ scope.row.interviewPlace }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        label="会议链接"
                        align="center"
                        min-width="160">
                    <template slot-scope="scope">
                        <div
                            v-if="scope.row.isEdit"
                            class="text-ellipsis"
                        >
                            <span
                                v-if="scope.row.interviewType === '5'" 
                                style="font-size: 12px;color: #c4c4c4"
                            >安排后自动生成</span>
                            <el-input
                                v-else
                                size="medium"
                                v-model="scope.row.conferenceLinks"
                                placeholder="请输入"
                                maxlength="1000"
                            ></el-input>
                        </div>
                        <div
                            v-else
                            class="text-ellipsis"
                        >
                            <a
                                v-if="scope.row.interviewType === '5'"
                                :href="scope.row.conferenceLinks"
                                target="_blank"
                            >{{ scope.row.conferenceLinks }}</a>
                            <span v-else>{{ scope.row.conferenceLinks || '' }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" min-width="180">
                    <template slot-scope="scope">
                        <div v-if="scope.row.isEdit">
                            <el-button type="text" @click.stop="onSubmit(scope.row, scope.$index)">保存</el-button>
                            <el-button type="text" @click.stop="toggleEdit(scope.row, scope.$index)">
                                <span class="color-danger">取消</span>
                            </el-button>
                        </div>
                        <div v-else>
                            <el-button class="hide" type="text" v-if="scope.row.id"
                                       @click.stop="showVisitorFlow(scope.row)">发起访客申请
                            </el-button>
                            <el-button type="text" @click.stop="toggleEdit(scope.row, scope.$index)"
                                       v-if="scope.row.id && scope.row.hasEvl !== true">编辑
                            </el-button>
                            <el-button type="text" v-if="scope.row.id && scope.row.hasEvl !== true"
                                       @click.stop="removeRow(scope.row, scope.$index)">
                                <span class="color-danger">删除</span>
                            </el-button>
                            <span v-if="scope.row.hasEvl" style="font-size: 12px;color: #c4c4c4">已评价不可操作</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <visitor-flow-handler ref="visitorFlow"></visitor-flow-handler>
    </div>
</template>

<script type="text/javascript">
    import axios from 'axios'
    import UserSearch from 'components/userSelect/searchDownList'
    import Thumbnail from 'components/thumbnail'
    import PIcon from 'components/pIcon'
    import VisitorFlowHandler from '../operation/vistorFlowDialog'
    import _ from 'underscore'
    import selectMapMixin from 'mixins/selectMapMixin'
    import { dateFormat } from 'modules/tools'
    import ArrangeCommon from './arrangeCommon'
    import dayjs from 'dayjs'

    export default {
        components: {
            UserSearch, VisitorFlowHandler, PIcon, Thumbnail, ArrangeCommon
        },
        mixins: [selectMapMixin],
        props: {
            init: Object,
            isSingle: {
                type: Boolean,
                'default': true
            }
        },
        computed: {
            hasMainInterview () {
                return !this.$store.state.app.isMutilInterview
            }
        },
        watch: {
            init (value) {
                this.rpId = value.id
                this.tableData = value.list
                this.tableData.forEach((item, index) => {
                    item.userSelectIndex = index
                })
                this.setTurnOptions(value.turnMap)
            }
        },
        created () {
            this.cacheData = {}
            this.setTurnOptions(this.init.turnMap)
            if (this.tableData.length === 0) {
                this.addInterview()
            } else {
                this.tableData.forEach((item, index) => {
                    item.userSelectIndex = index
                })
            }
        },
        data () {
            return {
                tableData: this.init.list || [],
                rpId: this.init.id,
                checked: false,
                turnMap: {},      // 显示
                turnOptions: [],    // 编辑
                interviewObject: {
                    interviewDate: '',
                    turnType: '',
                    interviewType: null,
                    interviewer: '',
                    masterInterviewer: '',
                    isHr: '',
                    id: null,
                    interviewPlace: ''
                },
                form: {
                    interviewDate: '',
                    interviewType: '',
                    turn: '',
                    turnName: '',
                    isHr: '',
                    turnType: '',
                    interviewer: '',
                    interviewerNames: '',
                    masterInterviewer: '',
                    masterInterviewerNames: '',
                    userSelectIndex: null,
                    id: null,
                    interviewPlace: '',
                    conferenceLinks: ''
                }
            }
        },
        methods: {
            selectedRow (row) {
                !row.isEdit && this.$refs.table.toggleRowSelection(row)
            },
            updateColData (rows, attr, value, names) {
                rows.forEach((item, index) => {
                    if (item.id === null || item.hasEvl === false) {
                        if (!item.isEdit) {
                            this.toggleEdit(item, index)
                        }
                        this.$nextTick(() => {
                            if (attr === 'masterInterviewer') {
                                let userIndex = item.userSelectIndex === undefined ? index : item.userSelectIndex
                                this.$refs[`masterInterviewer${userIndex}`].setDefaultValueLater(value, names)
                            } else {
                                this.$set(item, attr, value)
                            }
                        })
                    }
                })
            },
            toggleAllSelect (isSelect, checkedPhase = []) {
                this.tableData.forEach(item => {
                    if (checkedPhase.length) {
                        // 扩展全选一面，二面，三面和四面
                        this.$refs.table.toggleRowSelection(item, checkedPhase.indexOf(item.turnType.split(',')[0]) > -1)
                    } else {
                        // 原来的方式
                        this.$refs.table.toggleRowSelection(item, isSelect)
                    }
                })
            },
            removeInterview () {
                let ids = this.$route.params.ids.split(',')
                let index = ids.indexOf(this.rpId + '')
                ids.splice(index, 1)
                this.$router.replace({
                    name: 'multiArrangement',
                    params: {ids: ids.length ? ids.join(',') : -1}
                })
            },
            setInterviewsValue (data) {
                if (this.hasMainInterview) {
                    let ids = data.interviewer.split(',')
                    let index = ids.indexOf(data.masterInterviewer)
                    if (ids.length && index > -1) {
                        ids.splice(index, 1)
                        data.interviewer = ids.join(',')
                    }
                }
            },
            handleChangeInterviewType(newVal, index) {
                const oldVal = this.tableData[index].interviewType

                if (newVal !== '5' && oldVal === '5') {
                    this.tableData[index].conferenceLinks = ''
                }

                this.tableData[index].interviewType = newVal
            },
            addInterview () {
                let index = this.tableData.length
                if (index === 4) {
                    return false
                }
                this.tableData.push(Object.assign({
                    resumePositionId: this.rpId
                }, this.interviewObject, {
                    userSelectIndex: index
                }))
                this.$set(this.tableData[index], 'isEdit', true)
                return this.tableData[index]
            },
            toggleEdit (item, index) {
                this.$set(item, 'isEdit', !item.isEdit)
                if (item.isEdit) {
                    // this.setInterviewsValue(item)
                    this.$nextTick(function () {
                        let userIndex = item.userSelectIndex === undefined ? index : item.userSelectIndex
                        this.$refs[`masterInterviewer${userIndex}`].setDefaultValueLater(String(item.masterInterviewer), item.masterInterviewerNames)
                        let interviewers = item.interviewer.split(','), names = item.interviewerNames.split('，')
                        if (item.interviewer) {
                            console.log(1223423, item.interviewer, interviewers, names)
                            this.$refs.interviewer.setDefaultValueLater(interviewers, names)
                        }
                    })
                    this.cacheData[index] = Object.assign({}, item)
                } else {
                    if (item.id) {
                        this.setFormData(item, this.cacheData[index])
                        delete this.cacheData[index]
                        item = null
                    } else {
                        this.tableData.splice(index, 1)
                    }
                }
            },
            setFormData (item, data) {
                for (let key in this.form) {
                    this.$set(item, key, data[key])
                }
                this.form.interviewDate = data.interviewDate ? this.getDateObj(data.interviewDate) : ''
                let newTurnType = [data.turn, data.isHr].join(',')
                this.$set(item, 'turnType', newTurnType)
                this.form.turnType = newTurnType
            },
            getFormData (item) {
                let obj = {}
                for (let key in this.form) {
                    obj[key] = item[key]
                }
                if (obj.turnType) {
                    obj.turn = obj.turnType.split(',')[0]
                    obj.isHr = obj.turnType.split(',')[1]
                }
                return obj
            },
            removeRow (item, pIndex) {
                let that = this
                if (item.id) {
                    this.$confirm('确定删除该面试安排?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        axios.post('/resumePosition/interviewArrange/delete.api', {
                            resumePositionId: item.resumePositionId,
                            id: item.id
                        }, {'X-showMessage': true}).then(res => {
                            that.tableData.splice(pIndex, 1)
                        })
                    }).catch(() => {})
                }
            },
            getSelected () {
                return this.$refs.table.store.states.selection
            },
            sendEmail (type) {
                let data = this.getSelected()
                if (data.length === 0) {
                    this.$message({
                        message: '请勾选面试阶段',
                        type: 'warning'
                    })
                    return false
                }
                this.$emit('sendEmail', data, type)
            },
            checkData (item, curIndex) {
                let tips = ''
                if (item.turnType == null || item.turnType === '') {
                    tips = '面试阶段必填'
                } else if (item.interviewDate == null || item.interviewDate === '') {
                    tips = '面试时间必填'
                } else if (
                    item.interviewType === '5' &&
                    dayjs(item.interviewDate).isBefore(dayjs(), 'minute')
                ) {
                    tips = '面试时间不可小于当前时间'
                } else if (item.interviewType == null || item.interviewType === '') {
                    tips = '面试形式必填'
                } else if (item.interviewPlace == null || item.interviewPlace === '') {
                    tips = '面试地点必填'
                } else if (item.conferenceLinks && !/^https?:\/\//.test(item.conferenceLinks)) {
                    tips = '会议链接仅允许输入网址'
                }
                if (this.hasMainInterview) {
                    if (item.masterInterviewer == null || item.masterInterviewer === '') {
                        tips = '面试官必填'
                    }
                } else {
                    if (item.interviewer == null || item.interviewer === '') {
                        tips = '面试官必填'
                    }
                }
                // this.tableData.forEach((record, index) => {
                //     if (curIndex !== index && item.turn === record.turn) {
                //         tips = '该面试阶段已存在'
                //     }
                // })
                if (tips.length) {
                    this.$message({
                        message: tips,
                        type: 'warning'
                    })
                    return false
                } else {
                    return true
                }
            },
            collectionsSelectedData () {
                let params = []
                let hasError = false
                this.getSelected().forEach((item, index) => {
                    // 忽略已评价的数据
                    if (item.hasEvl !== true) {
                        let param = this.collectionsRowData(item, index)
                        param ? (params = params.concat(param)) : (hasError = true)
                    }
                })
                return hasError ? false : params
            },
            collectionsRowData (item, index) {
                let params = this.getFormData(item)
                if (this.checkData(params, index) === false) {
                    return false
                }
                let that = this
                params = Object.assign({}, params, {
                    interviewDate: this.dateFormat(params.interviewDate),
                    resumePositionId: this.rpId,
                    turn: item.turnType.split(',')[0],
                    isHr: item.turnType.split(',')[1]
                })
                return params
            },
            onSubmit (item, index) {
                let params = this.collectionsRowData(item, index)
                let that = this
                params && axios.post('/resumePosition/interviewArrange/save.api', params, {'X-showMessage': true}).then(res => {
                    let item = res.result.bean
                    this.$set(that.tableData[index], 'isEdit', !that.tableData[index].isEdit)
                    that.setFormData(that.tableData[index], item)
                    this.sortByTurn()
                    that.$forceUpdate()
                }).catch(() => {})
            },
            sortByTurn () {
                this.tableData = _.sortBy(this.tableData, (item) => item.turn)
            },
            dateFormat (date, format = 'yyyy-MM-dd hh:mm') {
                return dateFormat(date, format)
            },
            getDateObj (dateStr) {
                if (typeof dateStr === 'string') {
                    dateStr = dateStr.slice(0, 10)
                    let date = new Date()
                    date.setHours(0)
                    date.setMinutes(0)
                    date.setSeconds(0)
                    let arr = dateStr.split('-')
                    date.setFullYear(Number(arr[0]))
                    date.setMonth(Number(arr[1]) - 1)
                    date.setDate(Number(arr[2]))
                    return date
                } else {
                    return dateStr
                }
            },
            showVisitorFlow (item) {
                this.$refs.visitorFlow.show(item, this.init)
            },
            setTurnOptions (turnMap) {
                let turnOptions = []
                for (let turn in turnMap) {
                    turnOptions.push({
                        label: turnMap[turn],
                        value: [turn, '0'].join(',')
                    })
                    turnOptions.push({
                        label: turnMap[turn] + '（HR面）',
                        value: [turn, '1'].join(',')
                    })
                }
                this.turnMap = turnMap
                this.turnOptions = turnOptions
            }
        }
    }
</script>

<style lang="scss">
    @import "~variable";

    .scope-arrangement-item {
        margin-top : 10px;
        .img-wpr {
            img {
                width         : 72px;
                height        : 72px;
                border-radius : 100%;
            }
        }
        .dept-name {
            color       : #333;
            font-size   : 14px;
            margin-left : 20px;
            &.multi-info {
                font-weight : normal;
                color       : $text-color-third;
            }
        }
        .top-info {
            padding : 15px 13px;
            color   : #333;
            .name {
                font-size   : 16px;
                font-weight : bold;
            }
        }
        .el-table__header {
            th, div {
                background : #fafafa;
            }
        }
        .el-date-editor.el-input {
            width : 165px;
        }
        .el-table {
            .cell {
                padding-left  : 10px;
                padding-right : 10px;
            }
        }
        .user-type {
            width          : 18px;
            height         : 18px;
            text-align     : center;
            line-height    : 18px;
            color          : #fff;
            font-size      : 12px;
            background     : #11b970;
            display        : inline-block;
            border-radius  : 3px;
            margin-right   : 5px;
            vertical-align : text-bottom;
            &.user-main {
                background : #61a4ff;
            }
        }
        .text-ellipsis {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            a, span {
                overflow: hidden;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// arrangementItem.vue?28ee5bac